export default __webpack_public_path__ + "a9b288ce1cdbbe6d7072ef5b4e15fc7b.png";